import React from 'react';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import 'assets/scss/mobile-navigator-bar.scss';
import { Navurls, WORDPRESS_LINKS } from 'constants/links/NavLinks';

const createMobileUniqueLinks = (): Navurls[] => {
	const links = WORDPRESS_LINKS.map((link: Navurls) => {
		if (link.isContentSubLink) {
			return link.subLinks;
		} else {
			return link;
		}
	}).flat();
	return links as Navurls[];
};

export const MobileNavigatorBar = () => {
	const [isOpen, setIsOpen] = React.useState<boolean | undefined>(false);
	return (
		<>
			{isOpen ? (
				<CloseIcon
					onClick={() => setIsOpen(false)}
					fontSize="large"
					style={{
						cursor: 'pointer',
						position: 'fixed',
						top: 8,
						right: 8,
						zIndex: 3,
						color: '#fff',
					}}
				/>
			) : (
				<MenuIcon
					color="primary"
					onClick={() => setIsOpen(true)}
					fontSize="large"
					style={{
						cursor: 'pointer',
						position: 'absolute',
						top: 8,
						right: 8,
						zIndex: 2,
						backgroundColor: '#fff',
						borderRadius: 4,
					}}
				/>
			)}
			<div
				className={`mobile-navigator-container ${
					isOpen === true ? 'container-open' : 'container-close'
				}`}
			>
				<nav className="title-4">
					<ul>
						{createMobileUniqueLinks().map((link: Navurls, index) => {
							return (
								<li key={`link_${index}`}>
									<a href={link.url} key={`link_a_${index}`}>
										{link.title}
									</a>
								</li>
							);
						})}
					</ul>
				</nav>
			</div>
		</>
	);
};
